export default __webpack_public_path__ + "static/media/cross-icon.caff710c.svg";